import { useEffect, useState } from "react";
import Logo from "./Images/logoo.svg";
import UserIcon from "./Images/user.svg";
import { Link, useNavigate } from "react-router-dom";
import Login from "../Login/Login";
import { Cookies } from 'react-cookie'
import * as main_category from "../../network/api/maincategory.js";
import ImageSelection from "../searchwithimage/ImageSelection.jsx";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
const languages = [
  {
    code: 'en',
    name: 'English',
    country_code: 'gb',
  },
  {
    code: 'ar',
    name: 'العربية',
    dir: 'rtl',
    country_code: 'kw',
  },
]
function Nav({ personal, update_p }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchKey, setSearch] = useState("");
  const [id, setid] = useState("");
  const cookie = new Cookies()
  const token = cookie.get('user')
  const [countrycode, setcountrycode] = useState("kw");
  useEffect(() => {
    main_category
      .getcategories()
      .then((result) => {
        const firstId = result?.data?.response?.[0]?._id;
        if (firstId) setid(firstId);
      })
      .catch(() => {
        // no-op
      });
  }, []);
  const handleKeyPress = (e) => {
    // Check if the pressed key is Enter
    if (e.key === 'Enter' && searchKey.trim() !== '') {
      let page = 1
      // Trigger navigation to another component
      navigate(`/search-results/${searchKey}/${page}`);
      setSearch("")
    }
  };

  const handleLanguageChange = (code) => {
    i18next.changeLanguage(code)
  };

  const handlecountrycode = (code) => {
    setcountrycode(code)
  };

  const [countrylangg, setcountrylangg] = useState('العربية');
  const handlecountrylangg = (langg) => {
    setcountrylangg(langg)
  };

  return (
    <>
      {token ?
        <>
          <nav className="nav align-items-center d-none d-lg-flex">
            <div className="container d-flex align-items-center justify-content-between">
              <img src={Logo} alt="Logoo" style={{ cursor: "pointer", width: "82px", height: "58px" }} onClick={() => { navigate("/") }} />
              <input
                type="text"
                name="search"
                value={searchKey}
                placeholder={t("whatAreYouLookingFor")}
                onChange={(e) => { setSearch(e.target.value) }}
                onKeyPress={handleKeyPress}
                className="flex-grow-1"
              />
              <ImageSelection />
              <div className="list d-flex pb-1">
                <Link to="/profile">
                  <p>{t("MyAccount")}</p>
                  <img src={UserIcon} />
                </Link>
                <Link to="/wishlist">
                  <p className="mx-2"> {t("favorites")} </p>
                  <div style={{ position: "relative", width: "fit-content" }}>
                    {loveIcon}
                    <div className="text-danger w-100" style={{ position: "absolute", top: "3px", textAlign: "center", fontSize: ".8rem", fontWeight: "700" }}>
                      {personal?.wish?.length}
                    </div>
                  </div>
                </Link>
                <Link to="/cart">
                  <p className="mx-2"> {t("chart")}</p>
                  <div style={{ position: "relative", width: "fit-content" }}>
                    {cartIcon}
                    <div className="text-danger w-100" style={{ position: "absolute", top: "8px", textAlign: "center", fontSize: ".75rem", fontWeight: "700" }}>
                      {personal?.cart?.length}
                    </div>
                  </div>
                </Link>
                <div className='left d-flex align-items-center ' >
                  <div className="dropdown">
                    <button className=' mx-2 dropdown-toggle  ' style={{ border: "none", color: "white", backgroundColor: "#00000000" }} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <span className={`flag-icon flag-icon-${countrycode} mx-2`}></span>
                    </button>
                    <div className='dropdown-menu menu_div_nav' style={{ backgroundColor: "#00000000", border: "none", padding: "0px" }} >
                      <div className='d-flex flex-column '>
                        <svg style={{ position: "relative", left: "2rem", top: "0rem" }} xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 21 12" fill="none">
                          <path d="M0.184691 10.0535L10.0607 0.175268C10.3069 -0.0584526 10.6879 -0.0584526 10.9341 0.175268V0.187716L20.8101 10.0657C21.0562 10.2995 21.0562 10.6932 20.8101 10.927C20.6996 11.0499 20.5395 11.1114 20.3797 11.1114L0.615042 11.1114C0.283006 11.1114 0 10.8408 0 10.4963C0 10.3241 0.073927 10.1643 0.184691 10.0535Z" fill="white" />
                        </svg>
                        <ul className="ul_container-nav  bg-white " style={{ position: "relative", top: "-1px" }}>
                          <li
                            className='mx-2' style={{}}>
                            <span className='select-nav-div' >
                              {languages.map(({ code, name, country_code }) => (
                                <label key={country_code}
                                  className='select-nav'>
                                  <input
                                    type="radio"
                                    style={{ border: "2px solid black" }}
                                    name="language"
                                    value="EN"
                                    onChange={() => { handleLanguageChange(code); handlecountrylangg(name); handlecountrycode(country_code); }}
                                    className='d-none'
                                  />
                                  <span className={`flag-icon flag-icon-${country_code} mx-2`}></span>
                                  {name}
                                </label>
                              ))}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          <div style={{ direction: "ltr" }} className=" modal modal-xl fade" id="Login" tabIndex="-1" aria-labelledby="exampleModalToggleLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content" style={{ borderRadius: "0.3125rem", background: " #3C4242", border: "none" }}  >
                <div className="d-flex justify-content-center">
                  <div className="h-100 cancel-login" style={{ width: "32.771rem" }}                  >
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                      style={{ position: "relative", left: "1rem", top: "1rem" }}
                    ></button>
                  </div>
                  <div className="bg-white  text-white" style={{ width: "38.45rem" }}>
                    .
                  </div>
                </div>
                <div>
                  <Login></Login>
                </div>
              </div>
            </div>
          </div>
        </>
        :
        <>
          <nav className="nav align-items-center d-none  d-lg-flex ">
            <div className="container d-flex align-items-center justify-content-between">
              <img src={Logo} style={{ cursor: 'pointer' }} onClick={() => { navigate("/"); }} />
              <input
                type="text"
                name="search"
                value={searchKey}
                placeholder={t("whatAreYouLookingFor")}
                onChange={(e) => { setSearch(e.target.value) }}
                onKeyPress={handleKeyPress}
                className="flex-grow-1"
              />
              <div className="list d-flex flex-gow-1">
                <Link to="#Login" data-bs-toggle="modal">
                  <p>{t("login")}</p>
                  <img src={UserIcon} />
                </Link>
                {/* to="/wishlist"  */}
                <Link to="#Login" data-bs-toggle="modal">
                  <p className="mx-2"> {t("favorites")} </p>
                  {loveIcon}
                </Link>
                {/* to="/cart" */}
                <Link to="#Login" data-bs-toggle="modal" >
                  <p className="mx-2"> {t("chart")}</p>
                  {cartIcon}
                </Link>
                <div className='left d-flex align-items-center ' >
                  <div className="dropdown">
                    <button className=' mx-2 dropdown-toggle  ' style={{ border: "none", color: "white", backgroundColor: "#00000000" }} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <span className={`flag-icon flag-icon-${countrycode} mx-2`}></span>
                    </button>
                    <div className='dropdown-menu menu_div_nav' style={{ backgroundColor: "#00000000", border: "none", padding: "0px" }} >
                      <div className='d-flex flex-column '>
                        <svg style={{ position: "relative", left: "2rem", top: "0rem" }} xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 21 12" fill="none">
                          <path d="M0.184691 10.0535L10.0607 0.175268C10.3069 -0.0584526 10.6879 -0.0584526 10.9341 0.175268V0.187716L20.8101 10.0657C21.0562 10.2995 21.0562 10.6932 20.8101 10.927C20.6996 11.0499 20.5395 11.1114 20.3797 11.1114L0.615042 11.1114C0.283006 11.1114 0 10.8408 0 10.4963C0 10.3241 0.073927 10.1643 0.184691 10.0535Z" fill="white" />
                        </svg>
                        <ul className="ul_container-nav  bg-white " style={{ position: "relative", top: "-1px" }}>
                          <li
                            className='mx-2' style={{}}>
                            <span className='select-nav-div' >
                              {languages.map(({ code, name, country_code }) => (
                                <label key={country_code}
                                  className='select-nav'>
                                  <input
                                    type="radio"
                                    style={{ border: "2px solid black" }}
                                    name="language"
                                    value="EN"
                                    onChange={() => { handleLanguageChange(code); handlecountrylangg(name); handlecountrycode(country_code); }}
                                    className='d-none'
                                  />
                                  <span className={`flag-icon flag-icon-${country_code} mx-2`}></span>
                                  {name}
                                </label>
                              ))}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          <div style={{ direction: "ltr" }}
            className=" modal modal-xl fade " id="Login" tabIndex="-1" aria-labelledby="exampleModalToggleLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content "
                style={{ borderRadius: "0.3125rem", background: " #3C4242", border: "none" }}
              >
                <div className="d-flex justify-content-center ">
                  <div className="h-100 cancel-login" style={{ width: "32.771rem", backgroundColor: "" }}                  >
                    <button
                      type="button"
                      className="btn-close "
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      style={{ position: "relative", left: "1rem", top: "1rem" }}
                    ></button>
                  </div>
                  <div className="bg-white  text-white" style={{ width: "38.45rem" }}                  >
                  </div>
                </div>
                <div>
                  <Login></Login>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </>
  );
}
export default Nav;


const loveIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
    <mask id="mask0_610_1401" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="22">
      <path d="M0 0.885025H24V21.9221H0V0.885025Z" fill="white" />
    </mask>
    <g mask="url(#mask0_610_1401)">
      <mask id="mask1_610_1401" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="22">
        <path d="M1.80681 4.76224L1.80668 4.76245C0.180388 7.44629 1.28615 10.0691 2.79297 11.5205L12.1667 20.5292L21.3106 11.5835C22.7229 9.99994 23.2068 8.41018 22.9218 6.64891L22.9218 6.64881C22.5231 4.18285 20.4892 2.25711 17.9677 1.98219C16.4103 1.81408 14.927 2.25508 13.7723 3.21602C13.4599 3.4761 13.1815 3.76602 12.9388 4.08099L12.1625 5.08872L11.3666 4.09633C11.0789 3.73766 10.7384 3.40612 10.3484 3.10895L1.80681 4.76224ZM1.80681 4.76224C2.70413 3.28058 4.10968 2.28531 5.63548 1.98961M1.80681 4.76224L5.63548 1.98961M5.63548 1.98961C7.279 1.67387 8.99609 2.07962 10.3481 3.10869L5.63548 1.98961Z" stroke="white" stroke-width="2" />
      </mask>
      <g mask="url(#mask1_610_1401)">
        <path d="M0.951448 4.24422C-0.99454 7.45564 0.376602 10.5814 2.09921 12.2407L12.1729 21.9221L22.0336 12.2751C23.6359 10.4904 24.2501 8.59723 23.909 6.4892C23.4376 3.57331 21.039 1.31096 18.0757 0.988042C16.2582 0.791669 14.5028 1.3071 13.1324 2.44753C12.7636 2.75463 12.4341 3.09761 12.1467 3.47068C11.806 3.04591 11.4063 2.6578 10.9542 2.31327C9.37853 1.11381 7.37275 0.637348 5.44605 1.00772C3.6212 1.36111 1.98347 2.54013 0.951448 4.24422Z" stroke="black" stroke-width="2" />
      </g>
    </g>
  </svg>
);

const cartIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="29" viewBox="0 0 24 29" fill="none">
    <mask id="mask0_610_1389" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="5" width="24" height="24">
      <path d="M5 10.8681H19V23.8071H5V10.8681Z" fill="white" stroke="white" stroke-width="10" />
    </mask>
    <g mask="url(#mask0_610_1389)">
      <mask id="path-2-inside-1_610_1389" fill="white">
        <path d="M22.2288 28.8071H1.88563C1.39176 28.8071 0.912126 28.6011 0.573848 28.2417C0.233834 27.8826 0.0542762 27.3932 0.0820608 26.899L1.15316 7.61403C1.2063 6.6558 1.99781 5.90597 2.95673 5.90597H21.1581C22.117 5.90597 22.9085 6.6558 22.9613 7.61403L24.0324 26.899C24.0602 27.3932 23.8806 27.8826 23.541 28.2417C23.2013 28.6011 22.7227 28.8071 22.2288 28.8071ZM2.95673 7.11147C2.63755 7.11147 2.37221 7.36223 2.35554 7.68036L1.28444 26.9653C1.2761 27.1331 1.33376 27.2921 1.44837 27.4137C1.56402 27.5342 1.71823 27.6019 1.88563 27.6019H22.2288C22.3962 27.6019 22.5518 27.5342 22.6661 27.4137C22.7807 27.2921 22.8397 27.1331 22.83 26.9653L21.7589 7.68036C21.7422 7.36223 21.4773 7.11147 21.1581 7.11147H2.95673Z" />
      </mask>
      <path d="M22.2288 28.8071H1.88563C1.39176 28.8071 0.912126 28.6011 0.573848 28.2417C0.233834 27.8826 0.0542762 27.3932 0.0820608 26.899L1.15316 7.61403C1.2063 6.6558 1.99781 5.90597 2.95673 5.90597H21.1581C22.117 5.90597 22.9085 6.6558 22.9613 7.61403L24.0324 26.899C24.0602 27.3932 23.8806 27.8826 23.541 28.2417C23.2013 28.6011 22.7227 28.8071 22.2288 28.8071ZM2.95673 7.11147C2.63755 7.11147 2.37221 7.36223 2.35554 7.68036L1.28444 26.9653C1.2761 27.1331 1.33376 27.2921 1.44837 27.4137C1.56402 27.5342 1.71823 27.6019 1.88563 27.6019H22.2288C22.3962 27.6019 22.5518 27.5342 22.6661 27.4137C22.7807 27.2921 22.8397 27.1331 22.83 26.9653L21.7589 7.68036C21.7422 7.36223 21.4773 7.11147 21.1581 7.11147H2.95673Z" fill="black" />
      <path d="M0.573848 28.2417L7.85626 21.3885L7.84585 21.3774L7.83541 21.3664L0.573848 28.2417ZM0.0820608 26.899L10.0663 27.4603L10.0667 27.4535L0.0820608 26.899ZM1.15316 7.61403L11.1378 8.16858L11.1378 8.16772L1.15316 7.61403ZM22.9613 7.61403L12.9764 8.16412L12.9767 8.16858L22.9613 7.61403ZM24.0324 26.899L14.0478 27.4535L14.0482 27.4603L24.0324 26.899ZM23.541 28.2417L16.2759 21.3701L16.2726 21.3736L23.541 28.2417ZM2.35554 7.68036L12.3401 8.23491L12.341 8.21929L12.3418 8.20366L2.35554 7.68036ZM1.28444 26.9653L-8.70017 26.4108L-8.70179 26.4399L-8.70324 26.469L1.28444 26.9653ZM1.44837 27.4137L-5.82753 34.2738L-5.79728 34.3059L-5.76675 34.3377L1.44837 27.4137ZM22.6661 27.4137L29.9229 34.294L29.9324 34.2839L29.942 34.2738L22.6661 27.4137ZM22.83 26.9653L12.8454 27.5199L12.8461 27.532L12.8468 27.544L22.83 26.9653ZM21.7589 7.68036L11.7726 8.20366L11.7734 8.21929L11.7743 8.23491L21.7589 7.68036ZM22.2288 18.8071H1.88563V38.8071H22.2288V18.8071ZM1.88563 18.8071C4.13068 18.8071 6.29206 19.7263 7.85626 21.3885L-6.70857 35.0949C-4.46781 37.476 -1.34717 38.8071 1.88563 38.8071V18.8071ZM7.83541 21.3664C9.38477 23.0028 10.1932 25.2024 10.0663 27.4603L-9.90217 26.3377C-10.0847 29.584 -8.9171 32.7623 -6.68771 35.117L7.83541 21.3664ZM10.0667 27.4535L11.1378 8.16858L-8.83145 7.05948L-9.90255 26.3444L10.0667 27.4535ZM11.1378 8.16772C10.8976 12.4989 7.31574 15.906 2.95673 15.906V-4.09403C-3.32012 -4.09403 -8.48504 0.812721 -8.8315 7.06033L11.1378 8.16772ZM2.95673 15.906H21.1581V-4.09403H2.95673V15.906ZM21.1581 15.906C16.7997 15.906 13.2152 12.4989 12.9764 8.16412L32.9462 7.06394C32.6018 0.812753 27.4342 -4.09403 21.1581 -4.09403V15.906ZM12.9767 8.16858L14.0478 27.4535L34.017 26.3444L32.9459 7.05948L12.9767 8.16858ZM14.0482 27.4603C13.9213 25.2029 14.7293 23.0052 16.2759 21.3701L30.806 35.1133C33.032 32.7599 34.1991 29.5835 34.0166 26.3377L14.0482 27.4603ZM16.2726 21.3736C17.823 19.7328 19.9739 18.8071 22.2288 18.8071V38.8071C25.4715 38.8071 28.5795 37.4695 30.8093 35.1098L16.2726 21.3736ZM2.95673 -2.88853C-2.65209 -2.88853 -7.33416 1.49698 -7.63076 7.15706L12.3418 8.20366C12.0786 13.2275 7.92719 17.1115 2.95673 17.1115V-2.88853ZM-7.62908 7.12581L-8.70017 26.4108L11.2691 27.5199L12.3401 8.23491L-7.62908 7.12581ZM-8.70324 26.469C-8.84423 29.3065 -7.84333 32.1358 -5.82753 34.2738L8.72426 20.5536C10.5108 22.4484 11.3964 24.9596 11.2721 27.4616L-8.70324 26.469ZM-5.76675 34.3377C-3.82022 36.3661 -1.08367 37.6019 1.88563 37.6019V17.6019C4.52012 17.6019 6.94826 18.7023 8.66349 20.4897L-5.76675 34.3377ZM1.88563 37.6019H22.2288V17.6019H1.88563V37.6019ZM22.2288 37.6019C25.1635 37.6019 27.9359 36.3897 29.9229 34.294L15.4093 20.5333C17.1677 18.6787 19.629 17.6019 22.2288 17.6019V37.6019ZM29.942 34.2738C31.9164 32.1798 32.9845 29.3406 32.8133 26.3866L12.8468 27.544C12.695 24.9256 13.645 22.4045 15.3902 20.5536L29.942 34.2738ZM32.8146 26.4108L31.7435 7.12581L11.7743 8.23491L12.8454 27.5199L32.8146 26.4108ZM31.7452 7.15706C31.449 1.50432 26.7743 -2.88853 21.1581 -2.88853V17.1115C16.1802 17.1115 12.0355 13.2201 11.7726 8.20366L31.7452 7.15706ZM21.1581 -2.88853H2.95673V17.1115H21.1581V-2.88853Z" fill="black" mask="url(#path-2-inside-1_610_1389)" />
    </g>
    <mask id="mask1_610_1389" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="5" y="0" width="14" height="11">
      <path d="M10.9568 5H13.1376V5.7582H10.9568V5Z" fill="white" stroke="white" stroke-width="10" />
    </mask>
    <g mask="url(#mask1_610_1389)">
      <mask id="path-5-inside-2_610_1389" fill="white">
        <path d="M17.4785 10.7561C17.1458 10.7561 16.8759 10.4862 16.8759 10.1535V6.01709C16.8759 3.35811 14.7146 1.19577 12.057 1.19577C9.39943 1.19577 7.23814 3.35811 7.23814 6.01709V10.1535C7.23814 10.4862 6.96828 10.7561 6.6359 10.7561C6.30318 10.7561 6.03333 10.4862 6.03333 10.1535V6.01709C6.03333 2.69371 8.73573 -0.00973511 12.057 -0.00973511C15.3787 -0.00973511 18.0807 2.69371 18.0807 6.01709V10.1535C18.0807 10.4862 17.8109 10.7561 17.4785 10.7561Z" />
      </mask>
      <path d="M17.4785 10.7561C17.1458 10.7561 16.8759 10.4862 16.8759 10.1535V6.01709C16.8759 3.35811 14.7146 1.19577 12.057 1.19577C9.39943 1.19577 7.23814 3.35811 7.23814 6.01709V10.1535C7.23814 10.4862 6.96828 10.7561 6.6359 10.7561C6.30318 10.7561 6.03333 10.4862 6.03333 10.1535V6.01709C6.03333 2.69371 8.73573 -0.00973511 12.057 -0.00973511C15.3787 -0.00973511 18.0807 2.69371 18.0807 6.01709V10.1535C18.0807 10.4862 17.8109 10.7561 17.4785 10.7561Z" fill="black" />
      <path d="M17.4785 0.756107C22.6686 0.756107 26.8759 4.9634 26.8759 10.1535H6.87592C6.87592 16.0091 11.6229 20.7561 17.4785 20.7561V0.756107ZM26.8759 10.1535V6.01709H6.87592V10.1535H26.8759ZM26.8759 6.01709C26.8759 -2.16005 20.2422 -8.80423 12.057 -8.80423V11.1958C9.18709 11.1958 6.87592 8.87626 6.87592 6.01709H26.8759ZM12.057 -8.80423C3.8719 -8.80423 -2.76186 -2.16005 -2.76186 6.01709H17.2381C17.2381 8.87626 14.927 11.1958 12.057 11.1958V-8.80423ZM-2.76186 6.01709V10.1535H17.2381V6.01709H-2.76186ZM-2.76186 10.1535C-2.76186 4.96716 1.44168 0.756107 6.6359 0.756107V20.7561C12.4949 20.7561 17.2381 16.0053 17.2381 10.1535H-2.76186ZM6.6359 0.756107C11.826 0.756107 16.0333 4.9634 16.0333 10.1535H-3.96667C-3.96667 16.0091 0.780335 20.7561 6.6359 20.7561V0.756107ZM16.0333 10.1535V6.01709H-3.96667V10.1535H16.0333ZM16.0333 6.01709C16.0333 8.21205 14.2631 9.99026 12.057 9.99026V-10.0097C3.20838 -10.0097 -3.96667 -2.82464 -3.96667 6.01709H16.0333ZM12.057 9.99026C9.85096 9.99026 8.08073 8.21168 8.08073 6.01709H28.0807C28.0807 -2.82426 20.9064 -10.0097 12.057 -10.0097V9.99026ZM8.08073 6.01709V10.1535H28.0807V6.01709H8.08073ZM8.08073 10.1535C8.08073 4.96716 12.2843 0.756107 17.4785 0.756107V20.7561C23.3375 20.7561 28.0807 16.0053 28.0807 10.1535H8.08073Z" fill="black" mask="url(#path-5-inside-2_610_1389)" />
    </g>
  </svg>
)